import * as React from 'react';
import { User } from '../types/User';

interface Props {
  logout: () => void;
  user: User | null;
  children?: any;
}

const Jumbotron: React.SFC<Props> = (props: Props) => {
  const { user } = props;
  return (
    <section className="hero">
      <div className="app-container hero__inner">
        <div>
          <h1 className="hero__title">{user ? 'Welcome back' : 'Welcome'}</h1>
          {user && <p className="hero__subtitle">{user.email}</p>}
        </div>
      </div>
    </section>
  );
};

export default Jumbotron;
